import { observer } from "mobx-react-lite";
import { Button } from "@/components/ui/button";
import { Info, X } from "lucide-react";
import { useTran } from "@/hooks";
import { usePrefillStore } from "../../hooks/useDataEntryStore";
import { applyPrefillSuggestions } from "../../operations/prefill.ops";

const PrefillBanner = observer(() => {
  const { t } = useTran();
  const { showBanner, suggestions, dismiss, setShowModal } = usePrefillStore();

  if (!showBanner || !suggestions.length) return null;

  const frameworks = [...new Set(suggestions.map((m) => m.sourceFramework))];
  const entryCount = suggestions.reduce((sum, m) => sum + m.entries.length, 0);

  return (
    <div className="bg-blue-50 dark:bg-blue-950/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
      <div className="flex items-start gap-3">
        <Info className="h-5 w-5 text-blue-600 dark:text-blue-400 shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm font-medium text-blue-900 dark:text-blue-100">
            {t(
              "Found {{count}} matching entry(s) from {{frameworks}} that can be prefilled",
              {
                count: entryCount,
                frameworks: frameworks.join(", "),
              },
            )}
          </p>
          <div className="flex items-center gap-2 mt-3">
            <Button
              size="sm"
              variant="outline"
              onClick={() => setShowModal(true)}
            >
              {t("View Details")}
            </Button>
            <Button size="sm" onClick={applyPrefillSuggestions}>
              {t("Apply Values")}
            </Button>
            <Button size="sm" variant="ghost" onClick={dismiss}>
              {t("Dismiss")}
            </Button>
          </div>
        </div>
        <Button
          size="sm"
          variant="ghost"
          onClick={dismiss}
          className="shrink-0"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
});

export default PrefillBanner;
